import { t } from "ttag";

import type { Tab } from "./types";

export const TABS: Tab[] = [
  { label: t`Өмнөх`, direction: "last" },
  { label: t`Одоогийн`, direction: "current" },
  { label: t`Дараагийн`, direction: "next" },
];

export const DEFAULT_VALUE = {
  type: "relative",
  unit: "day",
  value: -30,
  offsetValue: undefined,
  offsetUnit: undefined,
} as const;
